export const DOCUMENTS_UPLOAD_PERMISSION = 'attachment#upload_attachments'
export const EMPLOYEE_UPLOAD_PERMISSION = 'employee#upload_attachments'

export const uploadAttachmentPermissionByAttachableType = Object.freeze({
  'Contractor::Company': 'company#upload_attachments',
  'Contractor::Contract': 'contract#upload_attachments',
  'Contractor::Asset': 'asset#upload_attachments',
  Asset: 'asset_v2#upload_attachments'
})

export const uploadAttachmentPermissionForAttachableType = (attachableType) => {
  return uploadAttachmentPermissionByAttachableType[attachableType] || null
}
